module.exports = require('./helpers/bundle-url').getBundleURL('jHzFK') + "pipeline.01d3d96a.png";